<template>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition"
              v-model="dialogVisible"
    >
    <v-sheet
            color="#DFDFDF"
            height="1000"
    >
        <v-toolbar color="#598377" short fixed dark>
            <v-btn icon dark @click="finished()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>{{ stack.name }} &ndash; {{ quizLevelName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn v-if="canEditCards" dark text @click="edit()">
                    <v-icon left>mdi-pencil</v-icon>
                    {{ $t('nav.edit') }}
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-sheet
                v-if="showFront"
                color="#DFDFDF"
                height="1000"
        >
            <h2 class="text-center"> {{ cardXofX }}</h2>
            <card-front>
                <div v-html="toHtml(card.front, card.lang)"></div>
            </card-front>
            <v-bottom-navigation
                    app
                    fixed
                    grow
                    color="primary"
            >
                <v-spacer></v-spacer>
                <v-btn
                        primary
                        @click="showAnswer()"
                >
                    <span>{{ $t('nav.showAnswer') }}</span>
                    <font-awesome-icon icon="question" />
                </v-btn>
                <v-spacer></v-spacer>
            </v-bottom-navigation>
        </v-sheet>
        <v-container v-else-if="showBack">
            <h2 class="text-center"> {{ cardXofX }}</h2>
            <v-spacer></v-spacer>
            <card-back>
                <template v-slot:front>
                    <div v-html="toHtml(card.front, card.lang)"></div>
                </template>
                <template v-slot:back>
                    <div v-html="toHtml(card.back, card.backLang)"></div>
                </template>
            </card-back>
            <v-bottom-navigation
                    app
                    fixed
                    grow
                    primary
                    value=""
            >
              <v-spacer></v-spacer>
                <v-btn
                        :color="green"
                        @click="markCorrect()"
                >
                    <span>{{ $t('nav.correct')}}</span>
                    <v-icon>done</v-icon>
                </v-btn>
                <v-btn
                        v-if="showEasy"
                        secondary
                        @click="markEasy()"
                        large
                >
                    <span>{{ $t('nav.easy') }}</span>
                    <v-icon>done</v-icon>
                </v-btn>
                <v-btn
                        :color="red"
                        @click="markWrong()"
                >
                    <span>{{ $t('nav.wrong') }}</span>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
            </v-bottom-navigation>
        </v-container>
        <v-container v-else>
            <h2 class="text-center">
                {{ $t('nav.loading') }}
            </h2>
        </v-container>
        <card-edit
                v-if="canEditCards"
                :pk="card.id"
                v-model="dialog"
                @closed="dialog = false"
                @saved="updateCard($event)"
        ></card-edit>
    </v-sheet>
    </v-dialog>
</template>

<script>
import GetUrl from "@/components/mixins/GetUrl";
// import BottomNav from "@/components/BottomNav";
import CardEdit from "./CardEdit";
import {arabic2hindi} from "@/lib/funclib";
import basic from "../mixins/basic";
import CardFront from "@/components/CardFront";
import CardBack from "@/components/CardBack";
// import DetailBase from "../bases/DetailBase";

export default {
    name: "CardQuiz",
    // extends: DetailBase,
    components: {CardBack, CardFront, CardEdit},
    mixins: [basic, GetUrl],
    props: {
        card: {
            required: true,
            type: Object
        },
        cardCount: {
            required: true,
            type: Number,
        },
        cardNumber: {
            required: true,
            type: Number,
        },
        stack: {
            required: true,
            type: Object,
        },
        quizLevel: {
            required: true,
            type: Number,
        },
    },
    data: function () {
        return {
            detailUrl: 'card',
            autoLoad: false,
            dialog: false,
            showFront: true,
            showBack: false,
            correct: false,
            easy: false,
            submitted: false,
            dialogVisible: true
        }
    },
    methods: {
        reset: function () {
            this.showFront = true;
            this.showBack = false;
            this.correct = false;
            this.easy = false;
            this.submitted = false;
        },
        showAnswer: function () {
            this.showFront = false;
            this.showBack = true;
        },
        markCorrect: function () {
            this.showBack = false;
            this.correct = true;
            this.submit();
        },
        markWrong: function () {
            this.showBack = false;
            this.correct = false;
            this.submit();
        },
        edit: function () {
            // this.$router.push({ name: 'card-update', params: { pk: this.card.id } })
            this.dialog = true;
        },
        markEasy: function () {
            this.showBack = false;
            this.easy = true;
            this.markCorrect()
        },
        finished: function () {
            this.dialogVisible = false;
            this.$emit('finished');
        },
        updateCard (card) {
            this.card.front = card.front;
            this.card.back = card.back;
        },
        submit: function () {
            this.submitted = true;
            let that = this;
            this.card.api.mark(this.correct, this.easy, this.stack.id).then(function (response) {
                that.data = response.data;
                that.show = false;
                that.$emit('done', that.correct, that.easy);
                that.reset();
            }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
                that.submitted = false
            });
        },
        successRoute () {
            return 'home';
        },
        getData () {
            return {
                correct: this.correct,
                easy: this.easy,
                stack_id: this.stack.id,
            }
        },
        onReset () {
            this.getDetail()
        },
    },
    computed: {
        showDialog () {
            return this.dialog;
        },
        frontCss: function () {
            // return 'lang-' + this.card.lang;
            return 'front ' + this.langCss(this.card.lang);
        },
        backCss: function () {
            return this.langCss(this.card.backLang) + ' back';
        },
        cardXofX () {
            let number = this.cardNumber;
            let count = this.cardCount;
            if (this.$store.state.lang === 'ar') {
                number = arabic2hindi(number);
                count = arabic2hindi(count);
            }
            return this.$t('heading.cardXofX', {number: number, count: count });
        },
        quizLevelName () {
            if (this.quizLevel === 0) {
                return this.$t('field.notMemorized')
            } else if (this.quizLevel === 1) {
                return this.$t('field.memorizedShortTerm')
            } else if (this.quizLevel === 2) {
                return this.$t('field.memorizedLongTerm')
            } else if (this.quizLevel === -1) {
                return this.$t('field.entireStack')
            }
            return '???';
        },
        showEasy () {
            return !this.card.status.level;
        }
    }
}
</script>

<style scoped>
    .front {
        font-size: 200%;
        text-align: center;
    }
    .back {
        font-size: 200%;
        text-align: center;
    }
</style>
